module.exports = __webpack_public_path__ + "img/generated-pumped.ca97acbe.png";